module.exports = __webpack_public_path__ + "static/media/apple_pay.518043ef.png";